import { ApiClient, ApiClientConfig } from "../api-client";
import { ApiClientError } from "../errors";
import schemaValidators from "./schema-validators";

export default class PlatformInfoClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, schemaValidators);
	}

	current = async () => {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/platform-info`);
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.platformInfo.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	isVersionSupported = async (version: string) => {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/platform-info/version/${version}`);
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.versionSupported.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
